export default __webpack_public_path__ + "static/media/cancel.0604220a.svg";